import type { BankAccount } from "@src/__generated__/graphql";
import type { IOption } from "@src/components/ui-kit";

export function paymentBankAccounts(bankAccounts: BankAccount[]): IOption[] {
  return bankAccounts.map((account) => ({
    value: account.id,
    label: account.iban,
  }));
}
